const WeatherService = (module.exports = {})

WeatherService.moonIconFromMoonPhase = function(theMoonPhase) {
  let moonPhase = -1 // 0 = new moon || waxing crescent ; 1 = first quarter || waxing gibbous ; 2 = full moon || waning gibbous ; 3 = last quarter || waning crescent
  let moonPhaseIdx = -1 // idx between 1 and 6 (both included) to know which icon to display
  let moonIconName
  let moonPhaseLabel

  if (!isNaN(theMoonPhase)) {
    moonPhase = Math.floor(theMoonPhase / 0.25)
    moonPhaseIdx = Math.round((theMoonPhase % 0.25) / (0.25 / 7))
    if (moonPhaseIdx >= 7) {
      moonPhaseIdx = 0
      moonPhase += 1
    }
    if (moonPhase >= 4) {
      moonPhase = 0
    }
    if (moonPhase === 0) {
      if (moonPhaseIdx === 0) {
        moonIconName = 'wi-moon-alt-new'
        moonPhaseLabel = 'new'
      } else {
        moonIconName = `wi-moon-alt-waxing-crescent-${moonPhaseIdx}`
        moonPhaseLabel = 'waxing-crescent'
      }
    } else if (moonPhase === 1) {
      if (moonPhaseIdx === 0) {
        moonIconName = 'wi-moon-alt-first-quarter'
        moonPhaseLabel = 'first-quarter'
      } else {
        moonIconName = `wi-moon-alt-waxing-gibbous-${moonPhaseIdx}`
        moonPhaseLabel = 'waxing-gibbous'
      }
    } else if (moonPhase === 2) {
      if (moonPhaseIdx === 0) {
        moonIconName = 'wi-moon-alt-full'
        moonPhaseLabel = 'full'
      } else {
        moonIconName = `wi-moon-alt-waning-gibbous-${moonPhaseIdx}`
        moonPhaseLabel = 'waning-gibbous'
      }
    } else if (moonPhase === 3) {
      if (moonPhaseIdx === 0) {
        moonIconName = 'wi-moon-alt-third-quarter'
        moonPhaseLabel = 'third-quarter'
      } else {
        moonIconName = `wi-moon-alt-waning-crescent-${moonPhaseIdx}`
        moonPhaseLabel = 'waning-crescent'
      }
    }
  }
  return {
    moonIconName,
    moonPhaseLabel,
  }
}
